export default {
    VISITA_DOMICILIAR_POS_OBITO: '0301050104',
    COLETA_MATERIAL_EXAME_LABORATORIAL: '0201020041',
    ANTIBIOTICOTERAPIA_PARENTERAL: '0301050082',
    ATENDIMENTO_MEDICO_FINALIDADE_ATESTAR_OBITO: '0301050090',
    TERAPIA_REIDRATACAO_PARENTERAL: '0301050120',
    ACOMPANHAMENTO_PACIENTE_REABILITACAO_COMUNICACAO_ALTERNATIVA: '0301070024',
    ATENDIMENTO_ACOMPANHAMENTO_REABILITACAO_MULTIPLAS_DEFICIENCIAS: '0301070067',
    ATENDIMENTO_ACOMPANHAMENTO_PACIENTE_REABILITACAO_DESENVOLVIMENTO_NEUROPSICOMOTOR: '0301070075',
    TERAPIA_FONOAUDIOLOGICA_INDIVIDUAL: '0301070113',
    CATETERISMO_VESICAL_ALIVIO: '0301100047',
    CATETERISMO_VESICAL_DEMORA: '0301100055',
    CUIDADOS_ESTOMAS: '0301100063',
    CUIDADOS_TRAQUEOSTOMIA: '0301100071',
    ENEMA: '0301100098',
    OXIGENOTERAPIA_DIA: '0301100144',
    RETIRADA_PONTOS_CIRURGIAS: '0301100152',
    SONDAGEM_GASTRICA: '0301100179',
    TERAPIA_DE_REIDRATACAO_ORAL: '0301100187',
    ATENDIMENTO_FISIOTERAPEUTICO_PACIENTE_TRANSTORNO_RESPIRATORIO_SEM_COMPLICACOES_SISTEMICAS: '0302040021',
    TRATAMENTO_EM_REABILITACAO: '0303190019',
    TRATAMENTO_DE_TRAUMATISMOS_DE_LOCALIZACAO_ESPECIFICADA_NAO_ESPECIFICADA: '0308010019',
    TRAQUEOSTOMIA: '0404010377',
}